import { BaseTool } from '../BaseTool';
import { useWorksharingStore } from '../../state/useWorksharingStore';
import { notify } from '../../utils/notify';
import i18n from '../../i18n';

/**
 * Reload Latest — pulls the newest central state without sending local
 * changes. Runs immediately (no dialog in BIM either).
 */
export class ReloadLatestTool extends BaseTool {
    id = 'COLLAB_RELOAD_LATEST';
    name = 'Reload Latest';
    cursor = 'default';

    onActivate(): void {
        void useWorksharingStore.getState().reloadLatest();
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** Publish Settings — cloud sheet/view publication picker. */
export class PublishSettingsTool extends BaseTool {
    id = 'COLLAB_PUBLISH_SETTINGS';
    name = 'Publish Settings';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('publishSettings');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** Cloud Models — manage cloud-hosted central model versions. */
export class CloudModelsTool extends BaseTool {
    id = 'COLLAB_CLOUD_MODELS';
    name = 'Cloud Models';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('cloudModels');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/**
 * Copy/Monitor — starts monitoring shared coordinates from a linked model
 * (Select Link) or the current project (Use Current Project). The variant is
 * passed to the dialog as a pre-selection hint.
 */
export class CopyMonitorTool extends BaseTool {
    id = 'COLLAB_COPY_MONITOR';
    name = 'Copy/Monitor';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('copyMonitor');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** Copy/Monitor > Select Link — dialog pre-focused on linked models. */
export class CopyMonitorSelectLinkTool extends BaseTool {
    id = 'COLLAB_COPY_MONITOR_SELECT_LINK';
    name = 'Copy/Monitor: Select Link';
    cursor = 'default';

    onActivate(): void {
        const hasLinks = Array.from(
            this.context?.bimStore.project.elements.values() ?? []
        ).some((el) => el.category === 'BIM Links');
        if (!hasLinks) {
            notify(i18n.t('tools.notify.noLinkedModelsFoundLinkA'), 'warning');
            this.context?.appStore.setActiveTool('select');
            return;
        }
        this.context?.appStore.openCollabDialog('copyMonitor');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** Copy/Monitor > Use Current Project — monitors current-project datums. */
export class CopyMonitorUseCurrentTool extends BaseTool {
    id = 'COLLAB_COPY_MONITOR_CURRENT';
    name = 'Copy/Monitor: Use Current Project';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('copyMonitor', 'current');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/**
 * Coordination Review — pending Copy/Monitor changes panel. Activating the
 * tool first refreshes notifications (BIM auto-checks on open).
 */
export class CoordinationReviewTool extends BaseTool {
    id = 'COLLAB_COORDINATION_REVIEW';
    name = 'Coordination Review';
    cursor = 'default';

    onActivate(): void {
        useWorksharingStore.getState().refreshCoordinationIssues();
        this.context?.appStore.openCollabDialog('coordinationReview');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
